import React from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import DeviceBrandsTable from "../components/Tables/DeviceBrandTable";
import { Button, Grid, CircularProgress, Alert } from "@mui/material";
import PageTitle from "../components/Layout/PageTitle";
import { Addchart } from "@mui/icons-material";
import { useDeviceBrands } from "../hooks/useDevices";

function DeviceBrands() {
  const { data: deviceBrands, isLoading, error, isError } = useDeviceBrands();

  if (isLoading) {
    return (
      <Grid container spacing={1} justifyContent="center">
        <Grid item xs={12} textAlign="center">
          <CircularProgress />
        </Grid>
      </Grid>
    );
  }

  if (isError) {
    return (
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Alert severity="error">
            Failed to load device brands: {error?.message || "Unknown error"}
          </Alert>
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      <Grid container spacing={1}>
        <PageTitle title="Device Brands">
          <Button variant="outlined" color="primary" disabled>
            <Addchart />
          </Button>
        </PageTitle>
        <Grid item xs={12}>
          <DeviceBrandsTable deviceBrands={deviceBrands} />
        </Grid>
      </Grid>
    </>
  );
}

export default withAuthenticationRequired(DeviceBrands);
